import { Link } from 'react-router-dom'
import Page from './Page'
import Hero from '../components/Hero'
import ProjectList from '../components/ProjectList'
import About from '../components/About'
import Reviews from '../components/Reviews'
import Icon from '../components/Icon'
import projects, { selected } from '../constants/works'

// A tier of four standard panels, then two beside the way into the full album.
const SPANS = [
  'md:col-span-6 lg:col-span-3',
  'md:col-span-6 lg:col-span-3',
  'md:col-span-6 lg:col-span-3',
  'md:col-span-6 lg:col-span-3',
  'md:col-span-6 lg:col-span-4',
]

const rest = projects.filter((p) => !p.selected)

const Home = () => (
  <Page>
    <Hero />

    <section
      id='work'
      tabIndex={-1}
      aria-labelledby='work-title'
      className='mx-auto max-w-page scroll-mt-20 px-gutter pt-tier'
    >
      <h2 id='work-title' className='sr-only'>
        Selected work
      </h2>
      <ProjectList items={selected} spans={SPANS}>
        <li className='panel flex flex-col justify-between gap-8 bg-sea p-5 text-paper md:col-span-12 md:p-8 lg:col-span-4 dark:text-ink'>
          <div>
            <p className='font-display uppercase text-h2'>{rest.length} more in the album</p>
            <p className='lettering mt-4 max-w-[60ch] text-paper/80 dark:text-ink/80'>
              {rest.map((p) => p.title).join(' · ')}
            </p>
          </div>
          <Link to='/portfolio' className='btn self-start text-[1.25rem]'>
            All {projects.length} projects <Icon name='right' />
          </Link>
        </li>
      </ProjectList>
    </section>

    <Reviews />
    <About />
  </Page>
)

export default Home
